import { render, staticRenderFns } from "./Statis.vue?vue&type=template&id=1620b8b4&scoped=true"
import script from "./Statis.vue?vue&type=script&lang=js"
export * from "./Statis.vue?vue&type=script&lang=js"
import style0 from "./Statis.vue?vue&type=style&index=0&id=1620b8b4&prod&scoped=true&lang=css"
import style1 from "./Statis.vue?vue&type=style&index=1&id=1620b8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620b8b4",
  null
  
)

export default component.exports